import { ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import * as formatters from './index.js';
function register() {
    ModelService.registerFormatter(formatters.DATE, formatters.DateFormatter);
    ModelService.registerFormatter(formatters.DIGIT, formatters.DigitFormatter);
    ModelService.registerFormatter(formatters.CURRENCY, formatters.CurrencyFormatter);
    ModelService.registerFormatter(formatters.FLOAT, formatters.FloatFormatter);
    ModelService.registerFormatter(formatters.INTEGER, formatters.IntegerFormatter);
    ModelService.registerFormatter(formatters.NUMERIC, formatters.NumericFormatter);
    ModelService.registerFormatter(formatters.PERSON_ID, formatters.PersonIdFormatter);
    ModelService.registerFormatter(formatters.POSTAL_CODE, formatters.PostalCodeFormatter);
}
export { register, };
//# sourceMappingURL=register.js.map